import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControlService } from '../form-control.service';
import { ControlValueAccessorImpl } from '../ng-material-impl/control-value-accessor.impl';
import createControlValueAccessorProvider from '../utils/create-control-value-accessor-provider';
import { DateFormControlService } from './date-form-control.service';

@Component({
  selector: 'ss-date-form-control',
  templateUrl: './date-form-control.component.html',
  styleUrls: ['./date-form-control.component.css'],
  providers: [
    FormControlService,
    DateFormControlService,
    createControlValueAccessorProvider(DateFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateFormControlComponent extends ControlValueAccessorImpl<Date> implements OnInit {

  readonly formatSubject = this._dateFormControlService.formatSubject;

  constructor(
    _formControlService: FormControlService,
    private _dateFormControlService: DateFormControlService
  ) {

    super()
  }


  ngOnInit(): void {

  }
}
